const formatedLocalStorage = (key) => JSON.parse(localStorage.getItem(key));

export default formatedLocalStorage;
